import Vue from "vue";
import store from "@/store/store";
import Router from "vue-router";
import moment from "moment";
import admin from "./admin";
import businessEntity from "./businessEntity";
import customers from "./customers";
import inventory from "./inventory";
import leads from "./leads";
import reports from "./reports";
import setup from "./setup";
import system from "./system";
import tickets from "./tickets";
import accounting from "./accounting";
import bill_management from "./bill-management";
import order_management from "./order_management";

export const routeHistoryData = [];
Vue.use(Router);

const router = new Router({
  mode: "hash",
  base: process.env.BUCKET_BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",

      beforeEnter: (to, from, next) => {
        let user = JSON.parse(sessionStorage.getItem("ngb:user"));
        if (
          store.getters["auth/isLogin"] ||
          (user && Object.keys(user).length > 0)
        ) {
          next();
        } else {
          next("Login");
        }
      },
      component: () => import("@/layouts/main/Main.vue"),
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: () => import("@/views/dashboard/dashboard.vue"),
        },
        {
          path: "/",
          name: "default",
          redirect: (to) => {
            return "dashboard";
          },
        },
        {
          path: "/profile",
          name: "Profile",
          component: () => import("@/views/profile/UserProfile.vue"),
        },
        admin,
        businessEntity,
        customers,
        inventory,
        leads,
        reports,
        setup,
        system,
        tickets,
        accounting,
        bill_management,
        order_management,
      ],
    },
    {
      path: "/",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        {
          path: "feedback/:id/code=:codeId",
          name: "Feedback",
          component: () => import("@/views/customers/view-customer/ticket/feedbackForm.vue"),
        },
        {
          path: "/login",
          name: "Page Login",
          component: () => import("@/views/auth/Login.vue"),
        },
        {
          path: "forgetPassword",
          name: "Forget Password",
          component: () => import("@/views/auth/forgetPassword.vue"),
        },
        {
          path: "forgetEmail",
          name: "Forget Email",
          component: () => import("@/views/auth/forgetEmail.vue"),
        },
        {
          path: "changePass",
          name: "Change Pass",
          component: () => import("@/views/auth/changePass.vue"),
        },
        {
          path: "forgetUserName",
          name: "Forget User Name",
          component: () => import("@/views/auth/forgetUserName.vue"),
        },
        {
          path: "error-404",
          name: "Page-Error-404",
          component: () => import("@/views/Error404.vue"),
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/error-404",
    },
  ],
});

router.afterEach((to, from) => {
  let r = routeHistoryData.length;
  let col = "primary";
  switch ((r % 5) + 1) {
    case 1: {
      col = "warning";
      break;
    }
    case 2: {
      col = "danger";
      break;
    }
    case 3: {
      col = "success";
      break;
    }
    case 4: {
      col = "grey";
      break;
    }
  }

  let time = moment().format("HH:mm:ss");
  let temp = { ...from, time: time, color: col };

  routeHistoryData.unshift(temp);
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
